export default [
	{
		path: ':id',
		component: () => import('@/pages/Ver/Ver/Pages/Index'),
		name: 'IndexVer',
		meta: {
			title: 'siS - Ver',
			noCache: true
		}
	}, {
		path: ':id/:empresa',
		component: () => import('@/pages/Ver/Ver/Pages/Index'),
		name: 'IndexVerEmpresa',
		meta: {
			title: 'siS - Ver',
			noCache: true
		}
	}
]